<script setup lang="ts">
interface Props {
  href?: string
  showArrow?: boolean
  as?: 'span' | 'div'
}

const props = withDefaults(defineProps<Props>(), {
  showArrow: true,
})
</script>

<template>
  <span class="inline-block group/button" >
    <component
      :is="as ? as : (href ? 'a' : 'button')"
      :href="props.href"
      class="px-4 gap-x-2 inline-flex py-2 items-center font-semibold border-2 border-brand-stroke/10 rounded-full text-xs text-center bg-brand-background/80 group-hover/button:border-brand-primary duration-300 ease-in-out"
    >
      <slot />
      <span v-if="showArrow" class="i-material-symbols:keyboard-arrow-right inline-block text-base mt-.5 group-hover/button:translate-x-1 duration-300 ease-in-out" />
    </component>    
  </span>
</template>
